import { TextButton } from "components/bootstrap/button-wrapper";
import React from "react";
import { Container } from "reactstrap";

const MktSection = (props) => {
  const {
    title,
    subtitle,
    link,
    size,
    className = "",
    titleClassName = "",
    children,
  } = props;

  return (
    <div className={"mkt-section" + className}>
      <Container>
        <div className="mkt-feature-section">
          <div className={"mkt-section-title " + titleClassName}>
            {title && <h2>{title}</h2>}
            {subtitle && <h6>{subtitle}</h6>}
            <hr />
          </div>
          <div className="mkt-section-see-more">
            <a href="/featured-stylists">
              <TextButton title="See More" size="lg" endIcon="chevron-right" />
            </a>
          </div>
        </div>
        <div className={"mkt-section-body " + size}>{children}</div>
      </Container>
    </div>
  );
};

export { MktSection };
